import { Subheader3, Stack } from '@collaborate-health/uikit'
import { FormElement } from '@collaborate-health/forms'

export interface SNCQuestionProps {
  element: FormElement
}

const SncQuestion: React.FC<SNCQuestionProps> = ({ element, children }) => {
  return (
    <Stack spacing={1}>
      <Subheader3>{element.name}</Subheader3>
      {children}
    </Stack>
  )
}

SncQuestion.displayName = 'SNCQuestion'

export default SncQuestion

